export {
  Gzip,
  Gunzip,
  gunzipSync,
  gzipSync,
  strFromU8,
  strToU8,
  unzipSync,
  unzlibSync,
  zipSync,
  zlibSync,
} from "fflate";
